import React, { useContext } from 'react'
import NumberFormat from 'react-number-format';
import he from 'he';
import { DiseaseGroupContext } from '../../contexts/diseaseGroupContext';
import * as dateFns from 'date-fns';

export const CostItem = ({ costItem, onShow }) => {

	const displayText = costItem && costItem.display && he.decode(costItem.display);

	const costItemDate = new Date(costItem?.incurred);

	const formattedTimeDate = dateFns.format(costItemDate, "iii do MMM yyyy")

	const { theme } = useContext(DiseaseGroupContext);

	return (
		<div onClick={() => onShow(costItem)} className={"w-full flex max-w-panel min-h-24 text-center mx-auto"}>
			<div className={`shadow-sm rounded-sm mr-0.5 w-4 max-w-panel grid grid-cols-4 gap-x-2 p-2 text-center my-1 xl:my-5 ${theme.cost().bg()}`}></div>
			<div className={`shadow-sm w-full rounded-sm max-w-panel grid grid-cols-7 gap-x-2 text-center my-1 xl:my-5 mx-auto ${theme.cost().bg()} bg-opacity-15`}>
				<div className={`col-span-6 text-white pl-6 pr-2 py-3.5 grid grid-cols-8`}>
					<div className={"col-span-3 w-full flex justify-start items-center text-black font-bold"}>
						<div className={"text-left text-lg flex items-center"}>
							£
							<NumberFormat
								thousandSeparator={true}
								displayType={"text"}
								decimalScale={2}
								fixedDecimalScale={true}
								value={costItem.amount}
							/>
						</div>
					</div>
					<div className={"col-span-5 w-full flex justify-end items-start text-black text-xs"}>{formattedTimeDate}</div>
					<div className={"text-black text-sm col-span-8 flex justify-start items-start pl-0.5 text-left"}>
						{displayText}
					</div>
				</div>
				<div className={`col-span-1 ${theme.cost().bg()} flex flex-col ${costItem.locked ? "justify-center items-center" : ""} rounded-sm text-app-todogrey font-bold text-base leading-tight cursor-pointer`}>
					<div className={"text-white font-bold text-xs sm:text-sm font-normal pt-1"}>{costItem.locked ? 'View' : 'Edit'}</div>
					{!costItem.locked && <div className="flex items-end justify-center h-full w-full pb-1 pl-1">
						<span className={"ss-icon text-3xl text-white"}>&#x1F4DD;</span>
					</div>}
				</div>
			</div>
		</div>

	)
}
